import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowDownIcon from '../../assets/icons/ArrowDownIcon';
import ArrowUpIcon from '../../assets/icons/ArrowUpIcon';
import { COLORS } from '../../styles/variables';
import {
  ExposedButton,
  FilterHeader,
  FilterTitle,
  FilterListWrapper,
  GreenDot,
  FilterList,
} from './Filters.style';
import { ExposedFiltersTypes } from '../../constants/initialFilters';

interface FilterExposedHeaderTypes {
  filterType: string;
  selectedFilterLabels: string[] | string;
  openedFiltersList: ExposedFiltersTypes;
  handleExposeFilter: (arg: string) => void;
}

const FilterExposedHeader: React.FC<FilterExposedHeaderTypes> = ({
  filterType,
  selectedFilterLabels,
  handleExposeFilter,
  openedFiltersList,
}) => {
  const { t } = useTranslation();

  const isRangeLabel =
    filterType === 'price' ||
    filterType === 'mileage' ||
    filterType === 'power' ||
    filterType === 'sortBy';

  const selectedFilters = useMemo(() => {
    if (!selectedFilterLabels) return '';
    if (isRangeLabel) return selectedFilterLabels;
    return (selectedFilterLabels as string[])
      ?.map((singleFilter) => {
        if (filterType === 'otherMakes' || filterType === 'nonAudiModels') return singleFilter;
        return t(`vlp.filters.filterOptions.${filterType}.${singleFilter}`);
      })
      .join(', ');
  }, [filterType, isRangeLabel, selectedFilterLabels, t]);

  return (
    <ExposedButton
      tabIndex={-1}
      onClick={() => handleExposeFilter(filterType)}
      data-testid="expose-filter-cta"
    >
      <FilterHeader>
        <FilterTitle>{t(`vlp.filters.filterTitle.${filterType}`)}</FilterTitle>
        {selectedFilters && (
          <FilterListWrapper data-testid="selected-filters-list">
            <GreenDot />
            <FilterList>{selectedFilters}</FilterList>
          </FilterListWrapper>
        )}
      </FilterHeader>
      {openedFiltersList[filterType] ? (
        <ArrowUpIcon color={COLORS.black} />
      ) : (
        <ArrowDownIcon color={COLORS.black} />
      )}
    </ExposedButton>
  );
};

export default FilterExposedHeader;
